import { render, staticRenderFns } from "./HuaxianVillageInfoDetail.vue?vue&type=template&id=fdfe860c&scoped=true&"
import script from "./HuaxianVillageInfoDetail.vue?vue&type=script&lang=js&"
export * from "./HuaxianVillageInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianVillageInfoDetail.vue?vue&type=style&index=0&id=fdfe860c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe860c",
  null
  
)

export default component.exports